import React from "react";

// Components
import { Input } from "antd";
import { SearchOutlined } from "@ant-design/icons";

const ManufacturerSearch = ({
  placeholder,
  width,
  height,
  borderRadius,
  bgColor,
  search,
  value
}) => {
  return (
    <Input
      onChange={search}
      value={value}
      placeholder={placeholder}
      prefix={<SearchOutlined />}
      style={{
        width: width,
        borderRadius: borderRadius,
        height: height,
        backgroundColor: bgColor,
      }}
    />
  );
};

export default ManufacturerSearch;
